import React from 'react';

import Supercluster from 'supercluster';

import { MAP_MAX_ZOOM } from '@kamernet/constants/Search';
import { MapMarker } from '@kamernet/core/ApiClient/Kamernet';

import { ListingsSearchContext } from '../../ListingsSearchContext';
import { groupListingsByCoords } from '../../utilities';

export const useMapClusters = () => {
  const { pinListings, allFilters } = ListingsSearchContext.useContext();

  const regularListingsCluster = React.useMemo(() => {
    const groupedPins = groupListingsByCoords(
      pinListings.map(listing => ({
        type: 'Feature',
        properties: {
          count: listing.count,
          latitude: listing.latitude,
          Longitude: listing.Longitude,
        },
        geometry: {
          type: 'Point',
          count: listing.count,
          coordinates: [
            parseFloat(listing.Longitude.toString()),
            parseFloat(listing.latitude.toString()),
          ],
        },
      })),
    );
    let regularListings: typeof groupedPins = [];
    regularListings = groupedPins;

    const superclusterObj = new Supercluster<
      { listings: MapMarker[]; cluster: false },
      { listings: MapMarker[] }
    >({
      maxZoom: MAP_MAX_ZOOM - 1,
      radius: 80,
      map: props => {
        return {
          listings: [...props.listings],
          type: 'cluster',
        };
      },
      // eslint-disable-next-line no-return-assign
      reduce: (acc, props) =>
        (acc.listings = acc.listings.concat(props.listings)),
    });
    superclusterObj.load(regularListings);

    return superclusterObj;
  }, [pinListings]);

  const getClusterZoom = React.useCallback(
    (id: number) => regularListingsCluster.getClusterExpansionZoom(id),
    [regularListingsCluster],
  );

  const clusters = React.useMemo(() => {
    const allClusters = regularListingsCluster.getClusters(
      [allFilters.nwlng, allFilters.selat, allFilters.selng, allFilters.nwlat],
      // on mobile devices we might get not an integer and it will cause failure of clustering,
      Math.max(0, Math.floor(allFilters.mapZoom)),
    );

    return allClusters;
  }, [
    allFilters.nwlat,
    allFilters.nwlng,
    allFilters.selat,
    allFilters.selng,
    allFilters.mapZoom,
    regularListingsCluster,
  ]);

  return { clusters, getClusterZoom };
};
